var _style, _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTb7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000087412982899649801690000001377591340530171071_",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 44,
    height: 44,
    viewBox: "0 0 42 42",
    style: {
      enableBackground: "new 0 0 42 42"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F7F2C6;stroke:#231F20;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st1{fill:#231F20;}\r\n")), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("sfw", {
    xmlns: "&ns_sfw;"
  }, /*#__PURE__*/React.createElement("slices", null), /*#__PURE__*/React.createElement("sliceSourceBounds", {
    bottomLeftOrigin: "true",
    height: 42,
    width: 42,
    x: 0,
    y: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 21,
    cy: 21,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.4,9.5h10.4c1,0,1.7,0.2,2.2,0.5c0.5,0.3,0.7,0.8,0.7,1.5c0,0.4-0.3,1-0.8,1.7c-0.5,0.7-1.1,1.5-1.8,2.4 c-0.7,0.9-1.4,2-2.1,3.2s-1.4,2.9-2,4.7c-0.2,0.8-0.4,1.5-0.5,2c-0.1,0.5-0.2,1.2-0.3,2.1c-0.1,0.9-0.2,1.5-0.3,2 c-0.2,1.1-0.5,1.8-0.9,2.2s-0.9,0.6-1.6,0.6c-0.6,0-1.1-0.2-1.5-0.7c-0.4-0.4-0.6-1.1-0.6-2c0-0.7,0.1-1.6,0.4-2.7 c0.3-1.1,0.7-2.5,1.4-4.1c0.6-1.6,1.4-3.2,2.4-4.9c1-1.7,2.1-3.4,3.4-5h-8.4c-0.9,0-1.5-0.2-1.9-0.5c-0.4-0.3-0.6-0.8-0.6-1.5 c0-0.7,0.2-1.2,0.7-1.4S14.6,9.5,15.4,9.5L15.4,9.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTb7);
export default __webpack_public_path__ + "static/media/Tb7.8638d119bfeb5675003a379038a08743.svg";
export { ForwardRef as ReactComponent };